import { render } from "./UploadPhoto.vue?vue&type=template&id=aa2489b6&scoped=true&ts=true"
import script from "./UploadPhoto.vue?vue&type=script&lang=ts"
export * from "./UploadPhoto.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2489b6"]])

export default __exports__